import { ContractType } from "@quantizr-engineering/common/types/show";
import { brandDealsDocMap } from "./brandDealMaps";
import { CreedInsuranceContractMap } from "./insuranceContractMaps";
import { CreedRecordLabelAgreementMap } from "./recordLabelAgreementMaps";
import { CreedShowOfferMap, liveAgreementDocMap, liveSettlementDocMap } from "./showMap";

export type FieldDefinition = {
  name: string;
  label: string;
  type:
    | "text"
    | "number"
    | "array"
    | "currency"
    | "select"
    | "boolean"
    | "date"
    | "percent"
    | "textArray"
    | "numberArray";
  required?: boolean;
  calcTotal?: Function;
  totalTooltipText?: string;
  options?: { label: string; value: string }[];
  subfields?: FieldDefinition[];
};

export type FieldsMap = {
  [otherKey: string]: FieldDefinition;
};

export type DocMap = {
  summaryFields: FieldsMap;
  dataFields: FieldsMap;
  entityHrefIcon: Function;
  entityHref: Function | null;
  entityHrefTitle: Function;
  entityHrefSubtitle: Function;
};

export const documentFieldMaps = {
  [ContractType.SHOW_OFFER]: CreedShowOfferMap,
  [ContractType.LIVE_MUSIC_AGREEMENT]: liveAgreementDocMap,
  [ContractType.LIVE_MUSIC_SETTLEMENT]: liveSettlementDocMap,
  [ContractType.BRAND_DEAL]: brandDealsDocMap,
  [ContractType.INSURANCE_CONTRACT]: CreedInsuranceContractMap,
  [ContractType.RECORDING_RECORD_LABEL_AGREEMENT]: CreedRecordLabelAgreementMap,
};
